import { useEffect, useState } from 'react'
import { Navigate } from 'react-router'

import { useActivationContext } from '../../providers/activation-provider'
import Api from '../../utils/api'

import CompleteSetupLeakFreeze from './device-types/leak-freeze'
import CompleteSetupSlim from './device-types/slim'

const CompleteSetup = () => {
  const { activationLocationState } = useActivationContext()
  const { folderId, nodeId, nodeTypeName } = activationLocationState

  const [node, setNode] = useState<INodeType | undefined>(undefined)

  useEffect(() => {
    if (nodeId) {
      Api.get(`/api/nodes/${nodeId}`).then((res) => {
        if (res.ok) {
          setNode(res.body)
        }
      })
    }
  }, [nodeId])

  if (nodeId && folderId && nodeTypeName === 'nbiot_leak') return <CompleteSetupLeakFreeze node={node} />
  if (nodeId && folderId && nodeTypeName === 'leak5s') return <CompleteSetupSlim node={node} />
  return <Navigate to="-1" />
}

export default CompleteSetup
